import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23115d3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading" }

import { Spin } from 'ant-design-vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CLoading',
  setup(__props) {

const aSpin = Spin;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(aSpin))
  ]))
}
}

})